const Build3Tab = ({ build3 }) => {
  if (!build3) return null

  return (
    <div className="overflow-x-auto">
      <h3 className="text-xl font-semibold text-white mb-6">
        Build3 Interest Submissions ({build3.length})
      </h3>
      <table className="min-w-full divide-y divide-white/10">
        <thead>
          <tr>
            {['Facilitator', 'Email', 'Entrepreneur Experience', 'Entrepreneur Needs', 'Online Modalities', 'Gift Culture', 'Date'].map(header => (
              <th key={header} className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-white/10">
          {build3.map((item) => (
            <tr key={item.id} className="hover:bg-white/5">
              <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-white">
                {item.facilitator.name}
              </td>
              <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-300">
                {item.facilitator.email}
              </td>
              <td className="px-4 py-4 text-sm text-gray-300 max-w-xs truncate">
                {item.submissionData.entrepreneurExperience}
              </td>
              <td className="px-4 py-4 text-sm text-gray-300 max-w-xs truncate">
                {item.submissionData.entrepreneurNeeds}
              </td>
              <td className="px-4 py-4 text-sm text-gray-300 max-w-xs truncate">
                {item.submissionData.onlineModalities}
              </td>
              <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-300">
                {item.submissionData.understandsGiftCulture ? '✅ Yes' : '❌ No'}
              </td>
              <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-300">
                {new Date(item.createdAt).toLocaleDateString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default Build3Tab
